import { render } from "./page-comissioner.vue?vue&type=template&id=b14d46ca&scoped=true"
import script from "./page-comissioner.vue?vue&type=script&lang=js"
export * from "./page-comissioner.vue?vue&type=script&lang=js"

import "./page-comissioner.vue?vue&type=style&index=0&id=b14d46ca&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b14d46ca"]])

export default __exports__